import { TrafficLightMarker } from './TrafficLightMarker';
import type { GroupDefinition, ColorCode } from '../../types/intersection';

interface IntersectionMarkersProps {
  groups: GroupDefinition[];
  groupColors: ColorCode[];
}

// Offsets for groups sharing the same pole (~3m displacement to avoid overlap)
const GROUP_OFFSETS: Record<number, [number, number]> = {
  5:  [0.00003, 0.00003],    // G5 shares pole with G13 (NE)
  13: [-0.00003, -0.00003],  // G13 shares pole with G5 (NE)
  8:  [0.00003, 0.00003],    // G8 near G11 (NE corner)
  11: [-0.00003, -0.00003],  // G11 near G8 (NE corner)
};

export function IntersectionMarkers({ groups, groupColors }: IntersectionMarkersProps) {
  return (
    <>
      {groups.map((group, index) => (
        <TrafficLightMarker
          key={group.id}
          group={group}
          colorCode={groupColors[index]}
          offset={GROUP_OFFSETS[group.id]}
        />
      ))}
    </>
  );
}
